module.exports = ".notreaded {\n  color: red; }\n\n.readed {\n  color: green; }\n"